import type { FormStepId } from 'shared/config/formStepId';
import { type IInitialEvent, sendEventInvalidForm } from 'shared/lib/sendGAEvents';

import { selectAllFormFields, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';
import { ContactsInfoTexts } from 'features/UpdateContactsInfo';
import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo';
import { PassportInfoTexts } from 'features/UpdatePassportInfo';
import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

import type { TStepValidationErrors } from './types';

export const validateErrorHandlerThunk =
  (
    errors: TStepValidationErrors[],
    steps: Array<ValuesOf<typeof FormStepId>>,
    analyticsOverrides?: Partial<Pick<IInitialEvent, 'event' | 'eventCategory'>>,
  ): ThunkResult<void> =>
  async (dispatch, getState) => {
    const formFields = selectAllFormFields(getState());
    const firstErrorStep = errors[0];
    const firstStepWithErrorIndex = steps.indexOf(firstErrorStep.formStepId);

    if (firstStepWithErrorIndex > 0) {
      dispatch(
        sendStepsAnalyticsEvents(
          Array.from({ length: firstStepWithErrorIndex }, (_, i) => i),
          {
            ...CreditPurposeInfoTexts,
            ...ContactsInfoTexts,
            ...PassportInfoTexts,
            ...WorkplaceInfoTexts,
            ...AdditionalInfoTexts,
          },
          'auto',
          analyticsOverrides,
        ),
      );
    }

    const firstErrorFieldName = firstErrorStep.errorFields[0];
    sendEventInvalidForm(
      firstStepWithErrorIndex + 1,
      'auto',
      firstErrorFieldName,
      JSON.stringify(formFields[firstErrorFieldName]),
      analyticsOverrides,
    );
  };
